import { newToolFilterOAuthMcp } from "../oauth.ts";

export const dialerMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://getdialer.app/apple-touch-icon.png",
  url: "https://getdialer.app/mcp",
  label: "Dialer",
});
